import type { ReactNode } from "react";

import PixelField from "./PixelField";

interface Props {
  eyebrow: ReactNode;
  /** Подпись справа в строке над заголовком: имя, счётчик. */
  aside?: ReactNode;
  title: ReactNode;
  seed?: number;
}

/**
 * Шапка экрана в стиле Maple: крупный заголовок и живая матрица из угла.
 *
 * Одна на все разделы, чтобы стиль держался не только на главной. Матрица
 * стекает из правого верхнего угла и гаснет к заголовку: узор не должен
 * спорить с тем, что читают.
 */
export default function ScreenHead({ eyebrow, aside, title, seed = 1 }: Props) {
  return (
    <header className="head">
      <PixelField className="head__field" seed={seed} />
      <div className="header">
        <span className="eyebrow">{eyebrow}</span>
        {aside !== undefined && <span className="eyebrow">{aside}</span>}
      </div>
      <h1 className="head__title">{title}</h1>
    </header>
  );
}
